import { Auth } from '@/type';
import api from '../API';
import { Credentials } from '../auth/credentials/types';
import { Account } from '../types';

export default {
  async findAll(platform: string, auth: Auth, credentials: Credentials): Promise<Account[]> {
    const response = await api.post(
      `platforms/${platform}/accounts`,
      { auth, credentials },
    );
    return response.data;
  },
};
